import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

export const getToken = () => {
  const token = Cookies.get("user_token");
  if (token) return token;
  else return null;
};

export const getDecodedToken = (tok) => {
  try {
    const token = tok ? tok : getToken();
    if (!token) return null;
    return jwtDecode(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};
const baseUrl = process.env.NEXT_PUBLIC_SERVER_URL;
//"BASEEEEEEE=========== : ", baseUrl)
const axiosApi = axios.create({
  // baseURL: "http://localhost:3000/api/v1",
  baseURL: baseUrl,
});

const GET = (url, body, config = {}) => {
  //"APIIIIIIIIIIIIIIIII GETTTTT", url, body, { ...config });
  return axiosApi.get(url, {
    ...config,
    headers: { authorization: "Bearer " + getToken() },
  });
};
const DELETE = (url, body, config = {}) => {
  return axiosApi.delete(url, {
    ...config,
    headers: { authorization: "Bearer " + getToken() },
  });
};
const POST = (url, body, config = {}) => {
  //"APIIIIIIIIIIIIIIIII", url, body, { ...config });
  return axiosApi.post(
    url,
    { ...body },
    {
      headers: { ...config, authorization: "Bearer " + getToken() },
    }
  );
};
const PUT = (url, body, config = {}) => {
  //"APIIIIIIIIIIIIIIIII PUTTTT", url, body, { ...config });
  return axiosApi.put(
    url,
    { ...body },
    {
      headers: { ...config, authorization: "Bearer " + getToken() },
    }
  );
};
const PostFile = (url, body, config = {}) => {
  return axiosApi.post(url, body, {
    ...config,
    headers: { authorization: "Bearer " + getToken() },
  });
};

const fetchPost = (url, payload, config = {}) => {
  return fetch(
    url,

    {
      method: "POST",
      headers: {
        ...config,
        "Content-Type": "application/json",
        authorization: "Bearer " + getToken(),
      },
      body: JSON.stringify(payload),
    }
  );
};

export { GET, POST, DELETE, PostFile, PUT, fetchPost };
